<template>
  <div class="row orders-view">
    <div class="col-lg-12 col-md-12 col-xs-12 noprint">
      <div class="row">
        <div class="fixed" >
          <div class="table-top" ref="tableTop" style="flex-shrink: 0;">
            <el-row>
              <el-col>
                <div class="search-filter-row">
                  <el-input @input="search" v-model="searchQuery" :placeholder="$t('general.search')" class="sm-search icon-search" style="flex: 1; min-width: 0;"></el-input>
                  <el-button type="default" class="filter-btn" @click="openFiltersModal" style="width: 15%; margin-bottom: 12px; flex-shrink: 0;">
                    <img src="/static/img/icons/filter.png">
                  </el-button>
                </div>
                <div class="pad-to-10 text-bold-500 filters-content" style="font-size: 13px; margin-top: 0; padding-top: 0;">
                  <template v-if="hasActiveFilters">
                    <div class="filters-header" @click="toggleFiltersCollapse">
                      <button class="collapse-toggle-btn" type="button">
                        <i :class="showFiltersCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'"></i>
                      </button>
                      <span>{{$t('orders.filtersApplied')}}:</span>
                    </div>
                    <div v-show="!showFiltersCollapsed" class="filters-list">
                      <span
                        v-for="(sts, key) in requestFilters[0].value"
                        :key="'status-filter-' + sts + '-' + key"
                        class="filter-selection">
                        {{formatLabelFirstLetter('ordersStatus.' + sts)}}<a title="Remove filter" href="#" @click.prevent="removeStatusFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                      </span>
                      <template v-if="showLocations">
                        <span
                          v-for="(locId, key) in locationFilter"
                          :key="'location-filter-' + locId + '-' + key"
                          class="filter-selection">
                          {{getLocationName(locId)}} <a title="Remove filter" href="#" @click.prevent="removeLocationFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                        </span>
                      </template>
                      <span v-if="orderFilters.preorders !== 'all'" class="filter-selection">
                        {{$t(orderFilters.preorders === '1' ? 'orders.pendingPreorders' : 'orders.withoutPendingPreorders')}}
                        <a title="Remove filter" href="#" @click.prevent="removePreordersFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a>
                      </span>
                      <template v-if="orderFilters.pickupDatetime && orderFilters.pickupDatetime.length === 2">
                        <span class="filter-selection">Pickup: {{formatDateRange(orderFilters.pickupDatetime)}} <a title="Remove filter" href="#" @click.prevent="removePickupDatetimeFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                      </template>
                      <template v-if="orderFilters.placedDatetime && orderFilters.placedDatetime.length === 2">
                        <span class="filter-selection">Placed: {{formatDateRange(orderFilters.placedDatetime)}} <a title="Remove filter" href="#" @click.prevent="removePlacedDatetimeFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                      </template>
                      <template v-if="orderFilters.orderId">
                        <span class="filter-selection">Order ID: {{orderFilters.orderId}} <a title="Remove filter" href="#" @click.prevent="removeOrderIdFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                      </template>
                      <template v-if="orderFilters.orderNumber">
                        <span class="filter-selection">Order #: {{orderFilters.orderNumber}} <a title="Remove filter" href="#" @click.prevent="removeOrderNumberFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                      </template>
                      <template v-if="orderFilters.orderTotalMin || orderFilters.orderTotalMax">
                        <span class="filter-selection">Total: {{orderFilters.orderTotalMin || '0'}} - {{orderFilters.orderTotalMax || '∞'}} <a title="Remove filter" href="#" @click.prevent="removeOrderTotalFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                      </template>
                      <template v-if="orderFilters.operator && orderFilters.operator.length > 0">
                        <span
                          v-for="(opId, key) in orderFilters.operator"
                          :key="'operator-filter-' + opId + '-' + key"
                          class="filter-selection">
                          Operator: {{getOperatorName(opId)}} <a title="Remove filter" href="#" @click.prevent="removeOperatorFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                        </span>
                      </template>
                      <template v-if="orderFilters.paymentType && orderFilters.paymentType.length > 0">
                        <span
                          v-for="(pt, key) in orderFilters.paymentType"
                          :key="'payment-type-filter-' + pt + '-' + key"
                          class="filter-selection">
                          Payment: {{formatLabelFirstLetter('paymentTypes.' + pt)}} <a title="Remove filter" href="#" @click.prevent="removePaymentTypeFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                        </span>
                      </template>
                      <template v-if="orderFilters.deliveryType && orderFilters.deliveryType.length > 0">
                        <span
                          v-for="(dt, key) in orderFilters.deliveryType"
                          :key="'delivery-type-filter-' + dt + '-' + key"
                          class="filter-selection">
                          {{$t('settingCompany.deliveryType')}}: {{formatLabelFirstLetter('deliveryTypes.' + dt)}} <a title="Remove filter" href="#" @click.prevent="removeDeliveryTypeFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                        </span>
                      </template>
                      <template v-if="orderFilters.source && orderFilters.source.length > 0">
                        <span
                          v-for="(src, key) in orderFilters.source"
                          :key="'source-filter-' + src + '-' + key"
                          class="filter-selection">
                          Source: {{formatLabelFirstLetter('ordersSource.' + src)}} <a title="Remove filter" href="#" @click.prevent="removeSourceFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                        </span>
                      </template>
                    </div>
                    <a href="#" @click.prevent="resetFilters()" class="reset-filters-link">{{$t('orders.resetFilters')}}</a>
                  </template>
                  <template v-else>
                    {{$t('orders.noFiltersApplied')}}
                  </template>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="card mar-to-15">
            <div class="card-content">

              <div class="data-table">
                <div class="table-container"
                  ref="tableContainerRef"
                  style="flex:1; overflow-y:auto; min-height:0;">

                  <el-table
                    :data="tableData"
                    v-loading="loading"
                    @row-click="goToRecord"
                    :row-class-name="rowClass"
                    style="width:100%">

                    <el-table-column label="ID / Nr." width="120">
                      <template slot-scope="props">
                        <div style="line-height: 1.2">
                          <!-- ID -->
                          <div>
                            <b>#{{ props.row.id }}</b>
                          </div>

                          <!-- Nr -->
                          <div style="font-size: 12px; margin-top: 10px; color: #7C8DB5;">
                            <template v-if="props.row.series">
                              {{ props.row.series }} -
                            </template>
                            {{ (parseInt(props.row.number) === 0) ? '@' : parseInt(props.row.number) }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>

                    <!-- 2. Date -->
                    <el-table-column :label="$t('gestiune.data')" width="130">
                      <template slot-scope="props">
                        {{formatDateTime(props.row.created_at)}}
                      </template>
                    </el-table-column>

                    <!-- 3. Labels -->
                    <el-table-column label="Labels" min-width="70" width="90">
                      <template slot-scope="props">
                        <template v-if="props.row.user_labeling">
                          <div v-html="convertLabelingJsonToHtml(props.row.user_labeling)"></div>
                        </template>
                      </template>
                    </el-table-column>

                    <!-- 4. Check-in -->
                    <!-- <el-table-column label="Check" width="110">
                      <template slot-scope="props">
                        <span v-if="props.row.check_in" class="checked__badge">
                          Checked-in
                        </span>
                      </template>
                    </el-table-column> -->

                    <!-- 5. Customer -->
                    <el-table-column :label="$t('gestiune.customer')" min-width="180">
                      <template slot-scope="props">
                        <div v-html="props.row.customer_display"></div>
                      </template>
                    </el-table-column>

                    <!-- 6a. Delivery - Location -->
                    <el-table-column :label="$t('gestiune.location')" min-width="140">
                      <template slot-scope="props">
                        {{ props.row.production_details && props.row.production_details.location ? props.row.production_details.location.name : '' }}
                      </template>
                    </el-table-column>

                    <!-- 6b. Delivery - Type -->
                    <el-table-column :label="$t('orders.type')" min-width="110">
                      <template slot-scope="props">
                        <template v-if="props.row.company_id === 31 && props.row.delivery_type === 'MEET_HALF'">
                          Due Drive
                        </template>
                        <template v-else-if="props.row.company_id === 46 && props.row.delivery_type === 'MEET_HALF'">
                          Yumm Drive
                        </template>
                        <template v-else>
                          {{props.row.delivery_type ? $t('deliveryTypes.' + props.row.delivery_type) : ''}}
                        </template>
                      </template>
                    </el-table-column>

                    <!-- 6c. Delivery - Pickup Time -->
                    <el-table-column :label="$t('orders.pickupTime')" min-width="170" width="180">
                      <template slot-scope="props">
                        <div class="box" style="display: flex; flex-direction: column">
                          <span v-if="props.row.delivery_type !== 'EAT_LOCATION' && props.row.just_date !== 1">
                            {{$t('orders.at')}} {{props.row.pickup_datetime | formatTime}}
                          </span>
                          <span v-else-if="props.row.delivery_type !== 'EAT_LOCATION' && props.row.just_date === 1">
                            {{$t('orders.at')}} {{formatDate(props.row.pickup_datetime)}}
                          </span>
                          <div v-if="props.row.delivery_moment">
                            <span class="text-color-red" style="display: inline-block;">
                              {{props.row.delivery_moment}}
                            </span>
                          </div>
                          <div v-if="isPreorder(props.row)">
                            <span class="text-color-red" style="display: inline-block;">
                              {{$t('orders.preorder')}}
                            </span>
                          </div>
                        </div>
                      </template>
                    </el-table-column>

                    <!-- 6d. Delivery - Delivery Moment -->
                    <!-- <el-table-column label="Delivery Moment" min-width="120">
                      <template slot-scope="props">
                        <div v-if="props.row.delivery_moment">
                          <span class="text-color-red" style="display: inline-block;">
                            {{props.row.delivery_moment}}
                          </span>
                        </div>
                      </template>
                    </el-table-column> -->

                    <!-- 7. Status -->
                    <el-table-column label="Status" width="160">
                      <template slot-scope="props">
                        <span class="label" :class="'label-' + orderStatusClass(props.row.status.id)">
                          {{changeDeliveryStatus(props.row.status.id, props.row.delivery_type)}}
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column :label="$t('orders.courier')" min-width="180" width="200">
                      <template slot-scope="props">
                        <span
                          v-if="getCourierDeliveryLabel(props.row)"
                          class="label"
                          :class="'label-' + getCourierDeliveryLabelClass(props.row)"
                        >
                          {{ getCourierDeliveryLabel(props.row) }}
                        </span>
                      </template>
                    </el-table-column>

                    <!-- 8. Total -->
                    <el-table-column label="Total" width="120">
                      <template slot-scope="props">
                        <b>{{props.row.totals_grandtotal}} {{getCurrencySymbol(props.row.currency)}}</b>
                      </template>
                    </el-table-column>

                  </el-table>
                </div>
                <el-pagination
                  class="active-pagination"
                  :total="paginationDef.totalRecords"
                  :page-size="paginationDef.perPage"
                  :pager-count="pagerCount"
                  :current-page="paginationDef.page"
                  layout="prev, pager, next, total"
                  @current-change="handlePageChange">
                </el-pagination>
              </div>

            </div>
          </div>
          <!-- <div class="orders-table-bottom table-bottom" ref="tableBottom" style="flex-shrink: 0;">
            {{$t('general.showing', {length: tableData.length})}}
            <a v-if="showLoadMore" class="btn btn-info btn-fill" @click.prevent="loadMore()">{{$t('general.loadMore')}}</a>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <div class="col-lg-9 col-md-8 col-xs-8 detailsScroll orders-print-full" ref="detailsScroll" :style="'height:' + (windowHeight - pageTopHeight) + 'px'">
      <order-form v-if="showForm()" ref="orderForm" :showLocations="showLocations" :callback="updateList"
      ></order-form>
      <div class="no-element" v-if="!showForm()">
        <i class="shopping-cart"></i>
        <div>{{$t('orders.noOrders')}}</div>
      </div>
    </div> -->

    <order-form
      v-if="showForm()"
      ref="orderForm"
      :showLocations="showLocations"
      :callback="updateList"
      :route="route">
    </order-form>

    <!-- Filters and Sort Modal -->
    <vmodal name="filtersAndSortModal" height="auto" width="1200" class="filtersAndSortModal">
      <div class="card">
        <div class="card-content">
          <div class="modal-header slim-header">
            <h4>{{$t('orders.filtersAndSort')}}</h4>
          </div>
          <div class="modal-body slim-body">
            <div class="filters-grid">
              <!-- Left Column -->
              <div class="modal-column-left">
                <h6 class="section-title">{{$t('orders.filters')}}</h6>

                <!-- Status Filter as buttons -->
                <div class="filter-section">
                  <h6>{{$t('orders.status')}}</h6>
                  <div class="button-group-wrap status-filter-buttons">
                    <button
                      v-for="key in filteredStatuses"
                      :key="key"
                      :class="'btn btn-status-filter ' + (modalRequestFilters[0].value.includes(key) ? 'btn-' + orderStatusClass(key) + ' current ' + key : 'btn-default')"
                      @click="toggleModalStatusFilter(key)">
                      {{formatLabelFirstLetter('ordersStatus.' + key)}}
                    </button>
                  </div>
                </div>

                <div class="filter-section">
                  <h6>{{$t('orders.preorderFilter')}}</h6>
                  <el-select v-model="modalOrderFilters.preorders" style="width: 100%;">
                    <el-option :label="$t('orders.allOrders')" value="all"></el-option>
                    <el-option :label="$t('orders.pendingPreorders')" value="1"></el-option>
                    <el-option :label="$t('orders.withoutPendingPreorders')" value="0"></el-option>
                  </el-select>
                </div>

                <!-- Delivery Method Filter -->
                <div class="filter-section">
                  <h6>{{$t('settingCompany.deliveryType')}}</h6>
                  <div class="button-group-wrap status-filter-buttons delivery-type-buttons">
                    <button
                      v-for="dt in deliveryTypeOptions"
                      :key="dt"
                      :class="'btn btn-status-filter ' + (modalOrderFilters.deliveryType && modalOrderFilters.deliveryType.includes(dt) ? 'btn-primary current ' + dt : 'btn-default')"
                      @click="toggleModalDeliveryTypeFilter(dt)">
                      {{formatLabelFirstLetter('deliveryTypes.' + dt)}}
                    </button>
                  </div>
                </div>

                <!-- Source buttons -->
                <div class="filter-section">
                  <h6>{{$t('orders.source')}}</h6>
                  <div class="button-group-wrap status-filter-buttons source-filter-buttons">
                    <button
                      v-for="src in sourceOptions"
                      :key="src"
                      :class="'btn btn-status-filter ' + (modalOrderFilters.source && modalOrderFilters.source.includes(src) ? 'btn-primary current ' + src : 'btn-default')"
                      @click="toggleModalSourceFilter(src)">
                      {{formatLabelFirstLetter('ordersSource.' + src)}}
                    </button>
                  </div>
                </div>

                <!-- Payment Type Filter -->
                <div class="filter-section">
                  <h6>{{$t('orders.payment')}}</h6>
                  <div class="button-group-wrap status-filter-buttons payment-type-buttons">
                    <button
                      v-for="pt in paymentTypeOptions"
                      :key="pt"
                      :class="'btn btn-status-filter ' + (modalOrderFilters.paymentType && modalOrderFilters.paymentType.includes(pt) ? 'btn-primary current ' + pt : 'btn-default')"
                      @click="toggleModalPaymentTypeFilter(pt)">
                      {{formatLabelFirstLetter('paymentTypes.' + pt)}}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Right Column -->
              <div class="modal-column-right">
                <!-- Pickup Datetime Filter -->
                <div class="filter-section">
                  <h6>{{$t('orders.pickupDatetime')}}</h6>
                  <el-date-picker
                    type="datetimerange"
                    v-model="modalOrderFilters.pickupDatetime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('orders.selectDateRange')"
                    @change="adjustDatetimeRange('pickupDatetime')"
                    style="width: 100%;">
                  </el-date-picker>
                </div>

                <!-- Placed Datetime Filter -->
                <div class="filter-section">
                  <h6>{{$t('orders.placedDatetime')}}</h6>
                  <el-date-picker
                    type="datetimerange"
                    v-model="modalOrderFilters.placedDatetime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('orders.selectDateRange')"
                    @change="adjustDatetimeRange('placedDatetime')"
                    style="width: 100%;">
                  </el-date-picker>
                </div>

                <!-- Location dropdown -->
                <template v-if="showLocations">
                  <div class="filter-section">
                    <h6>{{$t('orders.location')}}</h6>
                    <el-select
                      v-model="modalLocationFilter"
                      multiple
                      clearable
                      filterable
                      collapse-tags
                      class="w-100"
                      style="width: 100%;"
                      :placeholder="$t('orders.location')">
                      <el-option
                        v-for="loc in locations"
                        :key="'modal-location-' + loc.id"
                        :label="loc.name"
                        :value="loc.true_id">
                      </el-option>
                    </el-select>
                  </div>
                </template>

                <!-- Order ID Filter -->
                <div class="filter-section">
                  <h6>{{$t('orders.orderId')}}</h6>
                  <el-input
                    v-model="modalOrderFilters.orderId"
                    :placeholder="$t('orders.enterOrderId')">
                  </el-input>
                </div>

                <!-- Order Number Filter -->
                <div class="filter-section">
                  <h6>{{$t('orders.orderNumber')}}</h6>
                  <el-input
                    v-model="modalOrderFilters.orderNumber"
                    :placeholder="$t('orders.enterOrderNumber')">
                  </el-input>
                </div>

                <!-- Operator dropdown -->
                <div class="filter-section">
                  <h6>{{$t('orders.operator')}}</h6>
                  <el-select
                    v-model="modalOrderFilters.operator"
                    multiple
                    clearable
                    filterable
                    collapse-tags
                    class="w-100"
                    style="width: 100%;"
                    :placeholder="$t('reports.operator')">
                    <el-option
                      v-for="op in operatorOptions"
                      :key="'op-' + op.id"
                      :label="op.label"
                      :value="op.id">
                    </el-option>
                  </el-select>
                </div>

                <!-- Order Total Filter -->
                <div class="filter-section">
                  <h6>{{$t('orders.orderTotal')}}</h6>
                  <div class="range-row">
                    <el-input-number
                      v-model="modalOrderFilters.orderTotalMin"
                      :placeholder="$t('orders.min')"
                      :precision="2"
                      :controls="false"
                      style="flex: 1; line-height: 44px;">
                    </el-input-number>
                    <span>-</span>
                    <el-input-number
                      v-model="modalOrderFilters.orderTotalMax"
                      :placeholder="$t('orders.max')"
                      :precision="2"
                      :controls="false"
                      style="flex: 1; line-height: 44px;">
                    </el-input-number>
                  </div>
                </div>

                <!-- Sort -->
                <div class="filter-section">
                  <h6>{{$t('general.sortOrder')}}</h6>
                  <el-radio-group v-model="modalSortOrder">
                    <el-radio
                      v-for="sort in sortOptions"
                      :key="'sort-' + sort.id"
                      :label="sort.id"
                      style="display: block; margin-bottom: 10px;">
                      {{$t('general.sort' + sort.name)}}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>

            <div class="modal-footer slim-footer">
              <el-button type="default" size="small" @click="resetModalFilters">{{$t('general.reset')}}</el-button>
              <el-button type="primary" size="small" @click="applyFilters">{{$t('general.apply')}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Row, Select, Option, Checkbox, CheckboxGroup, Dropdown, DropdownMenu, DropdownItem, DatePicker, Button, InputNumber, Radio, RadioGroup} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import OrderForm from './OrderView.vue'
  import vmodal from 'vue-js-modal'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  Vue.use(Row)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(DatePicker)
  Vue.use(Button)
  Vue.use(InputNumber)
  Vue.use(Radio)
  Vue.use(RadioGroup)
  Vue.use(vmodal, { componentName: 'vmodal' })
  export default{
    components: {
      PPagination,
      PSwitch,
      OrderForm
    },
    computed: {
      hasActiveFilters () {
        const hasStatusFilters = this.requestFilters[0].value.length > 0
        const hasLocationFilters = this.showLocations && this.locationFilter.length > 0
        const hasPickupDatetime = this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2
        const hasPlacedDatetime = this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2
        const hasOrderId = this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== ''
        const hasOrderNumber = this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== ''
        const hasOrderTotal = this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null || this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null
        const hasOperator = this.orderFilters.operator && this.orderFilters.operator.length > 0
        const hasPaymentType = this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0
        const hasDeliveryType = this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0
        const hasSource = this.orderFilters.source && this.orderFilters.source.length > 0

        const hasPreorders = this.orderFilters.preorders !== 'all'

        return hasPreorders || hasStatusFilters || hasLocationFilters || hasPickupDatetime || hasPlacedDatetime ||
               hasOrderId || hasOrderNumber || hasOrderTotal || hasOperator || hasPaymentType || hasDeliveryType || hasSource
      },
      filteredStatuses () {
        return Object.keys(this.statuses).filter(key => key !== 'DRAFT')
      }
    },
    created () {
      this.buildWaitingTimeByMethodId()
      this.initializePage()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    data () {
      return {
        loading: true,
        timeoutGetData: null,
        isModalFilterChange: false, // Flag to prevent watcher from triggering during modal filter changes
        // Modal-specific filter variables (temporary until Apply is clicked)
        modalOrderFilters: {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: [],
          preorders: 'all'
        },
        route: {},
        modalLocationFilter: [],
        modalSortOrder: 1,
        modalRequestFilters: [{value: ['OPEN_DRAFT', 'NEW', 'ON_HOLD', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT']}],
        paginationDef: {
          page: null,
          perPage: 20,
          totalRecords: 0
        },
        pagerCount: 7,
        searchQuery: '',
        timeout: null,
        propsToSearch: ['status', 'price'],
        tableColumns: [
          {
            prop: 'number',
            label: 'Number',
            minWidth: 100
          },
          {
            prop: 'type',
            label: 'Type',
            minWidth: 100
          }
        ],
        orders: [],
        ordersReversed: [],
        useReversed: false,
        tableData: [],
        windowHeight: 0,
        tableTopHeight: 136,
        tableTopHeightFixed: 136,
        tableBottomHeight: 45,
        pageTopHeight: 0,
        // initialStatuses: ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'],
        requestLimit: 15,
        requestPage: 1,
        customFilter: false,
        showLoadMore: false,
        requestFilters: [
          {
            value: ['OPEN_DRAFT', 'NEW', 'ON_HOLD', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'] // status
          },
          {
            value: [] // location
          },
          {
            value: '' // search by test
          }
        ],
        locationFilter: [],
        sortOrder: 1,
        showFiltersCollapsed: false,
        operatorOptions: [],
        sourceOptions: [1, 2, 3, 4, 5, 6, 7, 8], // 1=Kiosk, 2=Qr, 3=Pos, 4=App, 5=Website, 6=Glovo, 7=Wolt, 8=Bolt
        paymentTypeOptions: ['CASH', 'CARD', 'POS', 'CARD_POS', 'CASH_MACHINE', 'POS_KIOSK', 'ONLINE', 'SPLIT', 'ROOM', 'FOLIO', 'EVENT', 'MANCARE_PERSONAL', 'PROTOCOL', 'VIRAMENT', 'GLOVO_CARD', 'GLOVO_CASH', 'BOLT_CASH', 'BOLT_CARD', 'WOLT_CASH', 'WOLT_CARD', 'null'],
        deliveryTypeOptions: ['PICK_UP', 'DELIVERY', 'EAT_LOCATION', 'MEET_HALF', 'SELF_ORDERING'],
        orderFilters: {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: [],
          preorders: 'all'
        },
        sortOptions: [
          {
            id: 1,
            name: 'CreatedDescending'
          },
          {
            id: 2,
            name: 'CreatedAscending'
          },
          {
            id: 3,
            name: 'PickupDescending'
          },
          {
            id: 4,
            name: 'PickupAscending'
          }
        ],
        resetFiltersObj: [{value: ['OPEN_DRAFT', 'NEW', 'ON_HOLD', 'POSTPONED', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT']}, {value: []}, {value: ''}],
        filters: [],
        statuses: this.$session.get('defaultData')['order_statuses']['ALL_DELIVERY_TYPES'],
        locations: [],
        showLocations: true,
        editedRowId: null,
        heartbeatSet: false,
        sessionNewOrders: 0,
        sessionProcessingOrders: 0,
        waitingTimeByMethodId: {}
      }
    },
    mounted () {
      this.$nextTick(() => {
        let companyLocations = this.$session.get('selectedCompanyData')
        for (var type in this.statuses) {
          if (type === 'ON_HOLD') {
            if (!companyLocations.is_allowed_on_hold) {
              delete this.statuses[type]
            }
          }
          if (type === 'POSTPONED') {
            if (!companyLocations.is_allowed_postponed) {
              delete this.statuses[type]
            }
          }
        }
        // console.warn('mounted')
        this.windowHeight = window.innerHeight
        this.tableTopHeight = (this.$refs.tableTop && this.$refs.tableTop.clientHeight) ? this.$refs.tableTop.clientHeight : 0
        this.tableTopHeightFixed = this.tableTopHeight
        // console.warn(window.innerWidth)
        if (window.innerWidth < 1200) {
          this.pageTopHeight = 0// 75
        } else {
          this.pageTopHeight = 0
        }

        window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
          this.tableTopHeight = (this.$refs.tableTop && this.$refs.tableTop.clientHeight) ? this.$refs.tableTop.clientHeight : 0
          // Only update fixed height if filters are expanded
          if (!this.showFiltersCollapsed) {
            this.tableTopHeightFixed = this.tableTopHeight
          }
          // console.warn(window.innerWidth)
          if (window.innerWidth < 1200) {
            this.pageTopHeight = 0// 75
          } else {
            this.pageTopHeight = 0
          }
        })

        if (!this.heartbeatSet) {
          this.heartbeat()
          this.heartbeatSet = true
        }
      })
    },
    methods: {
      buildWaitingTimeByMethodId () {
        const map = {}
        const companyData = this.$session.get('selectedCompanyData') || {}
        const locations = companyData.locations_details || []
        for (let i = 0; i < locations.length; i++) {
          const methods = locations[i].ordering_management || []
          for (let j = 0; j < methods.length; j++) {
            const method = methods[j]
            if (method && method.id != null) {
              map[String(method.id)] = Number(method.default_waiting_time) || 0
            }
          }
        }
        this.waitingTimeByMethodId = map
      },
      isPreorder (order) {
        if (!order || order.method_id == null || !order.pickup_datetime) {
          return false
        }
        const waitingMinutes = this.waitingTimeByMethodId[String(order.method_id)]
        if (waitingMinutes == null) {
          return false
        }
        const pickup = new Date(String(order.pickup_datetime).replace(' ', 'T'))
        if (isNaN(pickup.getTime())) {
          return false
        }
        const readyAt = Date.now() + waitingMinutes * 60 * 1000
        return pickup.getTime() > readyAt
      },
      handleRefresh (editedId) {
        this.initializePage()

        if (editedId) {
          this.editedRowId = editedId
        }
      },
      getCurrentPage () {
        if (this.paginationDef && this.paginationDef.page) {
          return this.paginationDef.page
        }
        return 1
      },
      handlePageChange (newPage) {
        this.paginationDef.page = newPage
        this.requestPage = newPage
        this.getData(false, false)
      },
      initializePage () {
        this.sessionNewOrders = parseInt(this.$session.get('newOrdersCount'))
        this.sessionProcessingOrders = parseInt(this.$session.get('processingOrdersCount'))
        if (this.$session.get('temp-status')) {
          if (this.$session.get('temp-status') === 'refreshSaveStatuses') {
            this.$session.remove('temp-status')
            // this.getData(true, false)
          } else {
            this.requestFilters[0].value = [this.$session.get('temp-status')]
            this.$session.remove('temp-status')
            // this.getData(true, false)
          }
        } else if (this.$session.get('saved-statuses')) {
          this.requestFilters[0].value = this.$session.get('saved-statuses')
          this.$session.remove('saved-statuses')
          // this.getData(true, false)
        } else {
          this.getData(false, false)
        }
        // var userData = JSON.parse(this.$session.get('userData'))
        // var companyKey = this.getObjectByElemKeyValue('company_id', this.$session.get('selectedCompany'), userData)
        // console.warn(companyKey)
        this.locations = this.$session.get('selectedCompanyData').locations_details
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations') || '[]')
        if ((!this.isOwner()) && allowedLocations.length) {
          this.locations = this.locations.filter(function (el) {
            return allowedLocations.includes(el.id)
          })
        }
        // if (this.locations.length > 1) {
        //   this.showLocations = true
        // }
        let filterCookie = this.$cookie.get('filter-orders-locations')
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie)
          // Normalize location filter to ensure integer true_id values
          this.locationFilter = this.normalizeLocationFilter(filterCookie)
        }

        this.getPosUsers()

        let sorOrderCookie = this.$cookie.get('sort-order')
        if (sorOrderCookie) {
          this.sortOrder = parseInt(sorOrderCookie) || 1
        } else {
          this.sortOrder = 1
        }
        window.removeEventListener('hashchange', this.dataEvent)
        window.addEventListener('hashchange', this.dataEvent)
      },
      dataEvent () {
        if (this.$refs.orderForm) {
          this.$refs.orderForm.getData()
        }
      },
      updateOrderStatusToProcessed (order) {
        var id = order.id
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          status: 'PROCESSING'
        }
        this.apiRequest('/order/' + id, 'PUT', data, response => {})
        this.getData(false, false)
        if (this.$refs.orderForm) {
          this.$refs.orderForm.getData()
        }
      },
      goToRecord (row, event, column) {
        var automatedProcessedStatus = this.$session.get('selectedCompanyData').automated_processed_status
        if (row.status.id === 'NEW' && automatedProcessedStatus) {
          this.updateOrderStatusToProcessed(row)
        }

        this.$router.push('/orders/view/' + row.id)
        // this.globalGoToRecord(row, event, column, '/orders/view/')
        // if (this.$refs.orderForm) {
        //   this.$refs.orderForm.getData()
        // }
      },
      heartbeat: function () {
        var self = this
        setInterval(() => {
          let sNO = parseInt(this.$session.get('newOrdersCount'))
          let sPO = parseInt(this.$session.get('processingOrdersCount'))
          // console.warn(self.customFilter)
          // console.warn('New in orders: ' + this.sessionNewOrders + ' in session: ' + sNO)
          // console.warn('Processing in orders: ' + this.sessionProcessingOrders + ' in session: ' + sPO)
          if (!self.customFilter && (this.sessionNewOrders !== sNO || this.sessionProcessingOrders !== sPO)) {
            self.getData(true, false)
          }

          this.sessionNewOrders = sNO
          this.sessionProcessingOrders = sPO
        }, 8000)
        setInterval(() => {
          if (self.$session.get('temp-status')) {
            if (this.$session.get('temp-status') === 'refreshSaveStatuses') {
              self.$session.remove('temp-status')
              self.getData(true, false)
            } else {
              self.requestFilters[0].value = [this.$session.get('temp-status')]
              self.$session.remove('temp-status')
              self.getData(true, false)
            }
          }
        }, 1000)
      },

      getData (isHeartBeat, isLoadMore) {
        this.$session.set('saved-statuses', this.requestFilters[0].value)
        // if (this.$session.get('temp-status')) {
        //   this.requestFilters[0].value = [this.$session.get('temp-status')]
        //   this.$session.remove('temp-status')
        // }
        // console.warn(isHeartBeat)
        if (!isHeartBeat) {
          this.$nextTick(() => {
            this.loading = true
          })
        }
        var self = this
        clearTimeout(self.timeoutGetData)
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          inactive: 1,
          limit: this.requestLimit,
          page: this.getCurrentPage(),
          sort_order: self.useReversed ? 'desc' : 'asc'
        }
        if (this.requestFilters[0].value.length) {
          data.statuses = this.requestFilters[0].value.join(',')
        }
        let filterCookie = this.$cookie.get('filter-orders-locations')
        if (this.locationFilter.length) {
          // Ensure all values are integers before joining
          const normalizedIds = this.locationFilter.map(id => parseInt(id, 10)).filter(id => !isNaN(id))
          data.location_ids = normalizedIds.join(',')
        } else if (filterCookie) {
          filterCookie = JSON.parse(filterCookie)
          if (filterCookie.length) {
            // Normalize cookie values to integer true_id values
            const normalizedCookie = this.normalizeLocationFilter(filterCookie)
            const normalizedIds = normalizedCookie.map(id => parseInt(id, 10)).filter(id => !isNaN(id))
            data.location_ids = normalizedIds.join(',')
          }
        }

        // Get sort order name from ID
        const sortOrderId = this.sortOrder || 1
        const sortOption = this.sortOptions.find(sort => sort.id === parseInt(sortOrderId))
        if (sortOption) {
          data.sort_order = sortOption.name
        } else {
          // Fallback to default if sort option not found
          data.sort_order = self.useReversed ? 'desc' : 'asc'
        }

        if (this.requestFilters[2].value !== '') {
          data.search = this.requestFilters[2].value
        }

        if (this.orderFilters.preorders !== 'all') {
          data.preorders = Number(this.orderFilters.preorders)
        }

        // Add new filter parameters
        if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
          data.pickup_datetime_from = this.orderFilters.pickupDatetime[0]
          // If end time is 00:00:00, change it to 23:59:59 to include the entire day
          data.pickup_datetime_to = this.adjustEndTime(this.orderFilters.pickupDatetime[1])
        }
        if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
          data.created_at_from = this.orderFilters.placedDatetime[0]
          // If end time is 00:00:00, change it to 23:59:59 to include the entire day
          data.created_at_to = this.adjustEndTime(this.orderFilters.placedDatetime[1])
        }
        if (this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '') {
          data.id = String(this.orderFilters.orderId).trim()
        }
        if (this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '') {
          data.order_number = this.orderFilters.orderNumber.trim()
        }
        if (this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null) {
          data.order_total_min = this.normalizeOrderTotal(this.orderFilters.orderTotalMin)
        }
        if (this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null) {
          data.order_total_max = this.normalizeOrderTotal(this.orderFilters.orderTotalMax)
        }
        if (this.orderFilters.operator && this.orderFilters.operator.length > 0) {
          data.operator = this.orderFilters.operator.join(',')
        }
        if (this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0) {
          data.payment_type = this.orderFilters.paymentType.join(',')
        }
        if (this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0) {
          data.delivery_type = this.orderFilters.deliveryType.join(',')
        }
        if (this.orderFilters.source && this.orderFilters.source.length > 0) {
          data.source = this.orderFilters.source.join(',')
        }

        var currentOrderId = null
        if (this.showForm()) {
          currentOrderId = parseInt(this.$route.params.id)
        }
        this.apiRequest('/orders-admin', 'GET', data, function (response) {
          if (response.status === true) {
            var goodOrders = []
            for (var idx in response.data) {
              if (response.data[idx]['status'].id === 'DRAFT') {
                // delete response.data[idx]
              } else {
                response.data[idx]['status_type'] = response.data[idx]['status'].id
                response.data[idx]['production_location'] = response.data[idx].production_details !== null ? response.data[idx].production_details.location.id : ''

                goodOrders.push(response.data[idx])

                if (isHeartBeat && currentOrderId === response.data[idx].id) {
                  if (self.$refs.orderForm) {
                    self.$refs.orderForm.heartbeat(response.data[idx])
                  }
                }
              }
              if (response.data[idx]['customer']) {
                let comment
                if (response.data[idx]['customer']['comment'] !== null) {
                  comment = '<i class="ti-info-alt text-color-red pad-lf-10" title="' + response.data[idx]['customer']['comment'] + '"></i>'
                } else {
                  comment = ''
                }
                if (response.data[idx]['customer']['firstname'] === null) {
                  if (response.data[idx]['delivery_details_firstname']) {
                    let name = response.data[idx]['delivery_details_firstname']
                    if (response.data[idx]['customer']['lastname']) {
                      name += ' ' + response.data[idx]['customer']['lastname']
                    }
                    response.data[idx]['customer_display'] = '<b>' + name + '</b>' + comment
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['delivery_details_phone'] + '</small>'
                  } else if (response.data[idx]['delivery_details_phone']) {
                    response.data[idx]['customer_display'] = '<b>' + response.data[idx]['delivery_details_phone'] + '</b>'
                  } else if (response.data[idx]['customer']['phone']) {
                    response.data[idx]['customer_display'] = '<b>' + response.data[idx]['customer']['phone'] + '</b>'
                  }
                  // if (response.data[idx]['customer']['email']) {
                  //   response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['email'] + '</small>'
                  // }
                  // response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><span class="xxs-font">' + self.$t('dashboard.nrOfOrders') + ': ' + response.data[idx]['counter_orders_per_customer'] + '</span>'
                } else if ((response.data[idx]['customer']['firstname'] !== null && response.data[idx]['customer']['lastname'] !== null) || (response.data[idx]['customer']['firstname'] !== null)) {
                  if (response.data[idx]['delivery_details_firstname']) {
                    let name = response.data[idx]['delivery_details_firstname']
                    if (response.data[idx]['customer']['lastname']) {
                      name += ' ' + response.data[idx]['customer']['lastname']
                    }
                    response.data[idx]['customer_display'] = '<b>' + name + '</b>' + comment
                  } else {
                    let name = response.data[idx]['customer']['firstname']
                    if (response.data[idx]['customer']['lastname']) {
                      name += ' ' + response.data[idx]['customer']['lastname']
                    }
                    response.data[idx]['customer_display'] = '<b>' + name + '</b>' + comment
                  }
                  if (response.data[idx].delivery_type !== 'SELF_ORDERING') {
                    if (response.data[idx]['delivery_details_phone']) {
                      response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['delivery_details_phone'] + '</small>'
                    } else if (response.data[idx]['customer']['phone']) {
                      response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['phone'] + '</small>'
                    }
                  }
                  if (response.data[idx].delivery_type === 'SELF_ORDERING' && response.data[idx]['table_id']) {
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['table_data']['zone'] + '</small>'
                  }
                  // if (response.data[idx]['customer']['email'] && response.data[idx].delivery_type !== 'SELF_ORDERING') {
                  //   response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['email'] + '</small>'
                  // }
                  // if (response.data[idx].delivery_type !== 'SELF_ORDERING') {
                  //   response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><span class="xxs-font">' + self.$t('dashboard.nrOfOrders') + ': ' + response.data[idx]['counter_orders_per_customer'] + '</span>'
                  // }
                } else {
                  response.data[idx]['customer_display'] = 'CCC'
                }
              } else {
                response.data[idx]['customer_display'] = ''
              }
            }

            if (goodOrders.length < self.requestLimit) {
              self.showLoadMore = false
            } else {
              self.showLoadMore = true
            }

            if (isLoadMore) {
              self.orders = self.orders.concat(goodOrders)
            } else {
              self.orders = goodOrders
            }
            // self.ordersReversed = self.orders.reverse()
            // self.tableData = self.useReversed ? self.orders : self.ordersReversed
            self.tableData = self.orders

            if (response.pagination) {
              self.paginationDef.totalRecords = response.pagination.totalRecords
              self.paginationDef.perPage = response.pagination.perPage
              self.paginationDef.currentPage = response.pagination.page
              self.paginationDef.totalPages = response.pagination.totalPages
            }

            self.scrollToCurrent()

            self.$nextTick(function () {
              self.loading = false
            })

            if (
              self.$session.get('selectedCompany') === 39 ||  // piata9
              self.$session.get('selectedCompany') === 50 ||  // Kintaro
              self.$session.get('selectedCompany') === 83 ||  // Ristretto
              self.$session.get('selectedCompany') === 90 ||  // Folkex
              self.$session.get('selectedCompany') === 106 || // Log Out Pub
              self.$session.get('selectedCompany') === 107 || // Casa Jelen
              self.$session.get('selectedCompany') === 100 || // WIID
              self.$session.get('selectedCompany') === 125 || // Real Burgers
              self.$session.get('selectedCompany') === 126 || // Dristor Kebap
              self.$session.get('selectedCompany') === 132 || // Almondo Pizza
              self.$session.get('selectedCompany') === 142 || // PULCINELLA TIMISOARA
              self.$session.get('selectedCompany') === 143 || // PULCINELLA CORBEANCA
              self.$session.get('selectedCompany') === 146 || // SHAORMERIA BANEASA
              self.$session.get('selectedCompany') === 164 || // FAMOUS GOURMET
              self.$session.get('selectedCompany') === 166 || // SALSA IASI
              self.$session.get('selectedCompany') === 201 || // Pelit Kebab
              self.$session.get('selectedCompany') === 30
              ) {
              self.timeoutGetData = setTimeout(function () {
                self.getData(false, false)
              }, 60000)
            }
          }
        })
      },
      scrollToCurrent () {
        this.$nextTick(function () {
          let el = this.$el.getElementsByClassName('current')[0]
          if (el) {
            var container = this.$refs.tableContainerRef
            var table = this.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody')
            var position = 1

            for (var i = 0; i < table.children.length; i++) {
              if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
                if (i > 1) {
                  position = i
                }
              }
            }
            container.scrollTo({
              left: 0,
              top: el.clientHeight * position,
              behavior: 'smooth'
            })
          }
        })
      },
      rowClass (rowData, index) {
        const row = rowData.row || rowData

        if (parseInt(row.id) === parseInt(this.editedRowId)) {
          return 'highlight-row'
        }

        if (this.$route.params.id && parseInt(row.id) === parseInt(this.$route.params.id)) {
          return 'current row-' + this.orderStatusClass(row.status.id)
        }

        return 'row-' + this.orderStatusClass(row.status.id)
      },
      showForm () {
        if (this.$route.path.indexOf('view') !== -1) {
          return true
        } else {
          return false
        }
      },
      removeFilter (filterKey, key) {
        if (filterKey === 0) {
          Vue.delete(this.requestFilters[filterKey].value, key)
        } else {
          Vue.delete(this.filters[filterKey].value, key)
        }
        this.tableTopHeight = this.$refs.tableTop.clientHeight
        this.updateCookie()
      },
      resetFilters () {
        this.customFilter = false
        this.requestPage = 1
        var filter = this.resetFiltersObj
        this.requestFilters = filter
        this.locationFilter = []
        this.orderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: [],
          preorders: 'all'
        }
        // Vue cookie plugin may not expose remove; expire the cookie instead
        this.$cookie.set('filter-locations', '', -1)
        this.$router.push('/orders')
        this.getData(false, false)
      },
      loadMore () {
        this.customFilter = true
        this.requestPage = this.requestPage + 1
        this.getData(false, true)
      },
      updateCookie () {
        // console.warn(this.locationFilter)
        // this.$cookies.config(60 * 60 * 24 * 30)
        this.$router.push('/orders')
        this.$cookie.set('filter-orders-locations', JSON.stringify(this.locationFilter), 30)
        this.requestPage = 1
        this.getData(false, false)
      },
      updateSortOrderCookie () {
        this.$router.push('/orders')
        this.$cookie.set('sort-order', this.sortOrder, 30)
        this.requestPage = 1
        this.getData(false, false)
      },
      updateList (id, status, pickupHour = null) {
        let idx = this.getObjectByElemKeyValue('id', parseInt(id), this.tableData)
        if (idx) {
          if (status) {
            this.tableData[idx]['status'] = status
            this.tableData[idx]['status_type'] = status['type']
          } else if (pickupHour) {
            this.tableData[idx]['pickup_datetime'] = pickupHour
          }
        }
      },
      openFiltersModal () {
        // Copy current filter values to modal variables
        this.modalRequestFilters = [{
          value: JSON.parse(JSON.stringify(this.requestFilters[0].value))
        }]
        // Normalize location filter to ensure integer true_id values
        this.modalLocationFilter = this.normalizeLocationFilter(this.locationFilter)
        // Use current sortOrder or default to first option (1) - ensure it's a number
        this.modalSortOrder = parseInt(this.sortOrder) || 1

        // Adjust datetime filters: if end time is 00:00:00, change to 23:59:59
        let pickupDatetime = null
        if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
          pickupDatetime = [
            this.orderFilters.pickupDatetime[0],
            this.adjustEndTime(this.orderFilters.pickupDatetime[1])
          ]
        }

        let placedDatetime = null
        if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
          placedDatetime = [
            this.orderFilters.placedDatetime[0],
            this.adjustEndTime(this.orderFilters.placedDatetime[1])
          ]
        }

        this.modalOrderFilters = {
          pickupDatetime: pickupDatetime,
          placedDatetime: placedDatetime,
          orderId: this.orderFilters.orderId,
          orderNumber: this.orderFilters.orderNumber,
          orderTotalMin: this.orderFilters.orderTotalMin,
          orderTotalMax: this.orderFilters.orderTotalMax,
          operator: JSON.parse(JSON.stringify(this.orderFilters.operator || [])),
          paymentType: JSON.parse(JSON.stringify(this.orderFilters.paymentType || [])),
          deliveryType: JSON.parse(JSON.stringify(this.orderFilters.deliveryType || [])),
          preorders: this.orderFilters.preorders,
          source: JSON.parse(JSON.stringify(this.orderFilters.source || []))
        }
        this.$modal.show('filtersAndSortModal')
      },
      applyFilters () {
        // Prevent watcher from triggering during filter application
        this.isModalFilterChange = true

        // Copy modal filter values to actual filters
        this.requestFilters[0].value = JSON.parse(JSON.stringify(this.modalRequestFilters[0].value))
        // Normalize location filter to ensure integer true_id values
        this.locationFilter = this.normalizeLocationFilter(this.modalLocationFilter)
        this.sortOrder = this.modalSortOrder

        // Adjust datetime filters: if end time is 00:00:00, change to 23:59:59
        let pickupDatetime = null
        if (this.modalOrderFilters.pickupDatetime && this.modalOrderFilters.pickupDatetime.length === 2) {
          pickupDatetime = [
            this.modalOrderFilters.pickupDatetime[0],
            this.adjustEndTime(this.modalOrderFilters.pickupDatetime[1])
          ]
        }

        let placedDatetime = null
        if (this.modalOrderFilters.placedDatetime && this.modalOrderFilters.placedDatetime.length === 2) {
          placedDatetime = [
            this.modalOrderFilters.placedDatetime[0],
            this.adjustEndTime(this.modalOrderFilters.placedDatetime[1])
          ]
        }

        this.orderFilters = {
          pickupDatetime: pickupDatetime,
          placedDatetime: placedDatetime,
          orderId: this.modalOrderFilters.orderId,
          orderNumber: this.modalOrderFilters.orderNumber,
          orderTotalMin: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMin),
          orderTotalMax: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMax),
          operator: JSON.parse(JSON.stringify(this.modalOrderFilters.operator || [])),
          paymentType: JSON.parse(JSON.stringify(this.modalOrderFilters.paymentType || [])),
          deliveryType: JSON.parse(JSON.stringify(this.modalOrderFilters.deliveryType || [])),
          preorders: this.modalOrderFilters.preorders,
          source: JSON.parse(JSON.stringify(this.modalOrderFilters.source || []))
        }
        // Update sort order cookie
        this.$cookie.set('sort-order', this.sortOrder, 30)
        this.$cookie.set('filter-locations', JSON.stringify(this.locationFilter), 30)
        this.$modal.hide('filtersAndSortModal')

        // Wait for next tick to ensure watcher has processed, then reset flag and call getData directly
        this.$nextTick(() => {
          this.isModalFilterChange = false
          this.requestPage = 1
          this.getData(false, false)
        })
      },
      resetModalFilters () {
        // Reset modal variables to default values (without applying)
        this.modalRequestFilters[0].value = ['OPEN_DRAFT', 'NEW', 'ON_HOLD', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT']
        this.modalLocationFilter = []
        this.modalSortOrder = 1
        this.modalOrderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: [],
          preorders: 'all'
        }
        // Now apply the reset filters
        this.requestFilters[0].value = JSON.parse(JSON.stringify(this.modalRequestFilters[0].value))
        this.locationFilter = JSON.parse(JSON.stringify(this.modalLocationFilter))
        this.sortOrder = this.modalSortOrder
        this.orderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: [],
          preorders: 'all'
        }
        // Update sort order cookie
        this.$cookie.set('sort-order', this.sortOrder, 30)
        // Don't close the modal - keep it open so user can see the reset values
        this.updateCookie()
      },
      removeStatusFilter (index) {
        this.requestFilters[0].value.splice(index, 1)
        this.updateCookie()
      },
      removeLocationFilter (index) {
        this.locationFilter.splice(index, 1)
        this.updateCookie()
      },
      removePreordersFilter () {
        this.orderFilters.preorders = 'all'
        this.updateCookie()
      },
      removePickupDatetimeFilter () {
        this.orderFilters.pickupDatetime = null
        this.updateCookie()
      },
      removePlacedDatetimeFilter () {
        this.orderFilters.placedDatetime = null
        this.updateCookie()
      },
      removeOrderIdFilter () {
        this.orderFilters.orderId = ''
        this.updateCookie()
      },
      removeOrderNumberFilter () {
        this.orderFilters.orderNumber = ''
        this.updateCookie()
      },
      removeOrderTotalFilter () {
        this.orderFilters.orderTotalMin = null
        this.orderFilters.orderTotalMax = null
        this.updateCookie()
      },
      removeOperatorFilter (index) {
        if (index !== undefined) {
          this.orderFilters.operator.splice(index, 1)
        } else {
          this.orderFilters.operator = []
        }
        this.updateCookie()
      },
      togglePaymentTypeFilter (paymentType) {
        this.isModalFilterChange = true // Set flag to prevent watcher from triggering
        if (!this.orderFilters.paymentType) {
          this.orderFilters.paymentType = []
        }
        const idx = this.orderFilters.paymentType.indexOf(paymentType)
        if (idx === -1) {
          this.orderFilters.paymentType.push(paymentType)
        } else {
          this.orderFilters.paymentType.splice(idx, 1)
        }
      },
      toggleModalPaymentTypeFilter (paymentType) {
        if (!this.modalOrderFilters.paymentType) {
          this.modalOrderFilters.paymentType = []
        }
        const idx = this.modalOrderFilters.paymentType.indexOf(paymentType)
        if (idx === -1) {
          this.modalOrderFilters.paymentType.push(paymentType)
        } else {
          this.modalOrderFilters.paymentType.splice(idx, 1)
        }
      },
      toggleModalDeliveryTypeFilter (deliveryType) {
        if (!this.modalOrderFilters.deliveryType) {
          this.modalOrderFilters.deliveryType = []
        }
        const idx = this.modalOrderFilters.deliveryType.indexOf(deliveryType)
        if (idx === -1) {
          this.modalOrderFilters.deliveryType.push(deliveryType)
        } else {
          this.modalOrderFilters.deliveryType.splice(idx, 1)
        }
      },
      removePaymentTypeFilter (index) {
        if (index !== undefined) {
          this.orderFilters.paymentType.splice(index, 1)
        } else {
          this.orderFilters.paymentType = []
        }
        this.updateCookie()
      },
      removeDeliveryTypeFilter (index) {
        if (index !== undefined) {
          this.orderFilters.deliveryType.splice(index, 1)
        } else {
          this.orderFilters.deliveryType = []
        }
        this.updateCookie()
      },
      formatLabelFirstLetter (translationKey) {
        try {
          const label = this.$t(translationKey)
          if (!label || typeof label !== 'string') {
            // Fallback: return the key after the last dot
            const fallback = translationKey.split('.').pop()
            return fallback ? fallback.toLowerCase().split(' ').map(word => {
              return word.charAt(0).toUpperCase() + word.slice(1)
            }).join(' ') : translationKey
          }
          // Convert to lowercase first, then capitalize first letter of each word
          return label.toLowerCase().split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
          }).join(' ')
        } catch (e) {
          // If translation fails, return formatted key
          const key = translationKey.split('.').pop()
          return key ? key.toLowerCase().split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
          }).join(' ') : translationKey
        }
      },
      getPosUsers () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/pos/all/users', 'GET', data, (response) => {
          if (response.status && response.data && response.data.pos_user) {
            this.operatorOptions = response.data.pos_user.map(user => ({
              id: user.id,
              label: `${user.firstname || ''} ${user.lastname || ''}`.trim() || `User ${user.id}`
            }))
          }
        })
      },
      removeSourceFilter (index) {
        if (index !== undefined) {
          this.orderFilters.source.splice(index, 1)
        } else {
          this.orderFilters.source = []
        }
        this.updateCookie()
      },
      toggleStatusFilter (key) {
        this.isModalFilterChange = true // Set flag to prevent watcher from triggering
        const idx = this.requestFilters[0].value.indexOf(key)
        if (idx === -1) {
          this.requestFilters[0].value.push(key)
        } else {
          this.requestFilters[0].value.splice(idx, 1)
        }
      },
      toggleModalStatusFilter (key) {
        const idx = this.modalRequestFilters[0].value.indexOf(key)
        if (idx === -1) {
          this.modalRequestFilters[0].value.push(key)
        } else {
          this.modalRequestFilters[0].value.splice(idx, 1)
        }
      },
      toggleSourceFilter (src) {
        this.isModalFilterChange = true // Set flag to prevent watcher from triggering
        if (!this.orderFilters.source) {
          this.orderFilters.source = []
        }
        const idx = this.orderFilters.source.indexOf(src)
        if (idx === -1) {
          this.orderFilters.source.push(src)
        } else {
          this.orderFilters.source.splice(idx, 1)
        }
      },
      toggleModalSourceFilter (src) {
        if (!this.modalOrderFilters.source) {
          this.modalOrderFilters.source = []
        }
        const idx = this.modalOrderFilters.source.indexOf(src)
        if (idx === -1) {
          this.modalOrderFilters.source.push(src)
        } else {
          this.modalOrderFilters.source.splice(idx, 1)
        }
      },
      toggleFiltersCollapse () {
        this.showFiltersCollapsed = !this.showFiltersCollapsed
        this.$nextTick(() => {
          if (!this.showFiltersCollapsed && this.$refs.tableTop) {
            this.tableTopHeight = this.$refs.tableTop.clientHeight
            this.tableTopHeightFixed = this.tableTopHeight
          }
        })
      },
      getLocationName (locationId) {
        const location = this.locations.find(loc => loc.true_id === locationId || loc.id === locationId)
        return location ? location.name : locationId
      },
      normalizeLocationFilter (locationFilter) {
        // Normalize location filter to ensure all values are integer true_id values
        if (!locationFilter || !Array.isArray(locationFilter) || locationFilter.length === 0) {
          return []
        }
        const normalized = []
        for (const value of locationFilter) {
          // Convert to number if it's a string representation of a number
          const numValue = typeof value === 'string' ? parseInt(value, 10) : value
          // Find location by true_id first, then by id as fallback
          const location = this.locations.find(loc => {
            if (loc.true_id === numValue || loc.true_id === value) return true
            if (loc.id === numValue || loc.id === value) return true
            // Check if value is a string and matches location properties
            if (typeof value === 'string') {
              return String(loc.true_id) === value || String(loc.id) === value
            }
            return false
          })
          if (location && location.true_id) {
            // Ensure true_id is an integer
            const trueId = parseInt(location.true_id, 10)
            if (!isNaN(trueId) && !normalized.includes(trueId)) {
              normalized.push(trueId)
            }
          }
        }
        return normalized
      },
      getOperatorName (operatorId) {
        const operator = this.operatorOptions.find(op => op.id === operatorId)
        return operator ? operator.label : operatorId
      },
      formatDateRange (dateRange) {
        if (!dateRange || dateRange.length !== 2) return ''
        return `${dateRange[0]} - ${dateRange[1]}`
      },
      normalizeOrderTotal (value) {
        if (value === null || value === undefined || value === '') {
          return null
        }
        const num = Number(value)
        // el-input-number turns empty fields into 0; do not treat that as a filter
        if (isNaN(num) || num === 0) {
          return null
        }
        return num
      },
      adjustEndTime (datetime) {
        // If the time is 00:00:00, change it to 23:59:59 to include the entire day
        if (datetime && datetime.endsWith('00:00:00')) {
          return datetime.replace('00:00:00', '23:59:59')
        }
        return datetime
      },
      adjustDatetimeRange (filterType) {
        // Adjust datetime range when user selects it in the date picker
        if (this.modalOrderFilters[filterType] && this.modalOrderFilters[filterType].length === 2) {
          // Create a new array to trigger reactivity
          this.modalOrderFilters[filterType] = [
            this.modalOrderFilters[filterType][0],
            this.adjustEndTime(this.modalOrderFilters[filterType][1])
          ]
        }
      },
      search () {
        // clear timeout variable
        clearTimeout(this.timeout)

        var self = this
        this.timeout = setTimeout(function () {
          // enter this block of code after 1 second
          // handle stuff, call search API etc.
          // console.log('searching:', self.searchQuery)
          self.requestFilters[2].value = self.searchQuery
        }, 500)
      },
      convertLabelingJsonToHtml (labeling) {
        const label = JSON.parse(labeling)
        const labelLevel = '<p style="color:' + label.color + ';">' + label.name + '</p>'
        return labelLevel
      },
      changeDeliveryStatus (statusUsed, deliveryType) {
        if (statusUsed === 'DELIVERED' && deliveryType === 'EAT_LOCATION') {
          statusUsed = 'reservedReady'
          return this.$t('ordersStatus.' + statusUsed)
        }
        if (statusUsed === 'DELIVERED' && deliveryType === 'PICK_UP') {
          statusUsed = 'completedReady'
          return this.$t('ordersStatus.' + statusUsed)
        }
        if (statusUsed === 'DELIVERED' && (deliveryType === 'MEET_HALF' || deliveryType === 'DELIVERY')) {
          statusUsed = 'deliveredReady'
          return this.$t('ordersStatus.' + statusUsed)
        }
        return this.$t('ordersStatus.' + statusUsed)
      },
      getCourierIntegrationStatus (order) {
        if (!order || order.delivery_type !== 'DELIVERY') return null

        const woltStatus = order.wolt_drive_status != null
          ? Number(order.wolt_drive_status)
          : (order.integration && order.integration.wolt_drive_status != null
            ? Number(order.integration.wolt_drive_status)
            : null)
        const deliveryHeroStatus = order.delivery_hero_status != null
          ? Number(order.delivery_hero_status)
          : (order.integration && order.integration.delivery_hero_status != null
            ? Number(order.integration.delivery_hero_status)
            : null)
        const glovoStatus = order.glovo_status != null ? Number(order.glovo_status) : null

        if (woltStatus != null && woltStatus > 0) {
          return { type: 'wolt_drive', status: woltStatus }
        }
        if (deliveryHeroStatus != null && deliveryHeroStatus > 0) {
          return { type: 'delivery_hero', status: deliveryHeroStatus }
        }
        if (glovoStatus != null && glovoStatus > 0) {
          return { type: 'glovo_laas', status: glovoStatus }
        }
        return null
      },
      isCourierDeliveryError (status) {
        return status === 3 || status === 6
      },
      getCourierDeliveryLabel (order) {
        const courier = this.getCourierIntegrationStatus(order)
        if (!courier) return ''
        if (this.isCourierDeliveryError(courier.status)) {
          return this.$t('orders.courierDeliveryError')
        }
        if (courier.status === 2) {
          return this.$t('orders.courierDeliverySuccess')
        }
        return ''
      },
      getCourierDeliveryLabelClass (order) {
        const courier = this.getCourierIntegrationStatus(order)
        if (!courier) return 'primary'
        if (this.isCourierDeliveryError(courier.status)) return 'danger'
        if (courier.status === 2) return 'success'
        return 'primary'
      }
    },
    watch: {
      requestFilters: {
        handler: function (newval, oldval) {
          // Skip if filter change is from modal (will be applied via applyFilters/resetModalFilters)
          if (this.isModalFilterChange) {
            return
          }

          let self = this
          let onlyDefaults = newval[0]['value'].filter(function (elm) {
            return self.resetFiltersObj[0]['value'].indexOf(elm) === -1
          })

          let rev = false
          // if (newval[2]['value'] === '' && (
          //       (newval[0]['value'].length === 7 && onlyDefaults) ||
          //       (newval[0]['value'].length === 1 && newval[0]['value'][0] === 'NEW') ||
          //       (newval[0]['value'].length === 1 && newval[0]['value'][0] === 'PROCESSING'))
          // ) {
          if (!onlyDefaults.length) {
            this.customFilter = false
            rev = false
          } else {
            this.customFilter = true
            rev = true
          }
          this.useReversed = rev

          this.requestPage = 1
          // this.$router.push('/orders')
          this.getData(false, false)

          // do something when the data changes.
          /*
          let all = newval[0]['value']
          let rev = false
          if (all.length === 0) {
            rev = true
          } else {
            for (var i in all) {
              if (!this.initialStatuses.includes(all[i])) {
                rev = true
              }
            }
          }
          */

          // this.tableData = this.useReversed ? this.orders : this.ordersReversed
          // this.tableData = this.useReversed ? this.ordersReversed : this.orders

          this.paginationDef.pageSize = this.tableData.length + 1
        },
        deep: true
      }
    }
  }
</script>
<style scoped>
  .orders .el-table td {
    text-align: left !important;
  }
  .orders-view .fixed {
    height: auto;
  }
  .orders .fixed .cell {
    padding: 0px;
  }
  .orders .el-table tr {
    margin: 10px !important;
    display: grid;
    padding: 0px !important;
    border: 1px solid #E6EFFB;
    border-radius: 20px;
  }
  .orders .orders-table tr:last-of-type td {
    border-bottom: none;
  }
  .orders .orders-table td,
  .orders .orders-table tr.active {
    background: #F4F6FF !important;
  }
  .orders .el-table .current.row-warning td:last-of-type {
    border-right-color: rgba(243, 187, 69, 0) !important;
  }
  .orders .el-table .el-table__row td {
    border: 1px solid transparent;
    border-radius: 20px;
    background: #E6EFFB;
    padding: 0px !important;
    border-right: none !important;
  }
  .orders .row-container {
    margin: 0px !important;
  }
  .orders .columns-container {
    background: #fff;
    border-radius: 20px;
    padding: 20px;
    position: relative;
  }
  .checked__badge {
    background: rgb(94, 53, 177);
    color: #fff;
    padding: 0px 7px;
    border-radius: 10px;
    text-transform: uppercase;
    font-size: 0.75em;
    display: inline-block;
  }
  .deliverFyTime {
    padding-top: 50px;
  }
  .deliveryTime span {
    font-size: 14px;
    font-weight: 500;
  }
  .orderStatusMenu {
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .customer {
    margin-bottom: 17px;
    font-size: 17px;
    font-weight: 400 !important;
  }
  .customer b {
    font-weight: 500;
  }
  .row-container {
    display: flex;
    flex-direction: column;
  }
  .total {
    font-size: 16px;
    margin-top: 20px;
    font-weight: 500;
  }
  .date span {
    font-size: 10px;
    color: #7C8DB5;
  }
  .userLabeling {
    background: #FFEBEA;
    color: #FF0D19;
    padding: 10px 30px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    position: absolute;
    top: 0;
    right: 20px;
  }
  .orders .el-table .el-table__row:hover td,
  .orders .el-table .current td {
    background: #5420BE !important;
    border: 1px solid #5420BE !important;
  }
  .deliveryTime {
    position: absolute;
    bottom: 20px;
  }
  .deliveryTime span {
    font-size: 15px;
  }
  .orders .el-table .el-table__row:hover .date span,
  .orders .el-table .el-table__row:hover .oderId,
  .orders .el-table .el-table__row:hover .oderId span,
  .orders .el-table .current td .date span,
  .orders .el-table .current td .oderId,
  .orders .el-table .current td .oderId span {
    color: #fff !important;
  }
  .userLabeling p {
    color: #FF0D19 !important;
    margin-bottom: 0px;
    text-align: center;
    font-size: 12px;
  }
  .status span {
    border-radius: 50px;
    padding: 5px 12px;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 12px !important;
  }
  .order-column-right {
    width: 68% !important;
  }
  .order-id {
    padding: 12px 0px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .oderId {
    color: #25396F;
    font-weight: 600;
  }
  .order-id .date {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .order-id .date img{
    margin-right: 5px;
    position: relative;
    bottom: 2px;
  }
  .oderId span {
    font-size: 16px;
    color: #7C8DB5;
    font-weight: 600;
  }
  .columns-container {
    display: flex;
    justify-content: space-between;
  }

  .column-left, .column-right {
    width: 48%; /* Adjust widths to fit within the container */
  }

  .orders .sm-search {
    width: 100%;
  }

  .orders .sm-search .el-input {
    width: 100%;
  }

  .orders .sm-search .el-input__inner {
    width: 100%;
  }

  .orders .table-top {
    padding: 0px 10px 0px 10px !important;
    height: auto;
    flex-shrink: 0;
  }

  .orders .table-top .filters-content {
    min-height: 30px;
  }

  .orders .table-top .search-filter-row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-bottom: 5px;
  }

  .orders .table-top .pad-to-10 {
    padding-top: 0 !important;
    padding-bottom: 5px !important;
  }

  .orders .search-filter-row .filter-btn {
    height: auto;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .filter-selection {
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 3px;
    padding: 4px 4px !important;
    background: #f0f0f0;
    border-radius: 4px;
    font-size: 12px;
  }

  .orders-table-bottom.table-bottom {
    padding: 8px 10px !important;
    min-height: auto !important;
    height: auto !important;
  }

  .orders-table-bottom.table-bottom .btn {
    padding: 5px 15px;
    font-size: 13px;
  }

  .reset-filters-link {
    margin-left: 10px;
    color: #409eff;
    text-decoration: none;
  }

  .reset-filters-link:hover {
    text-decoration: underline;
  }

  .filters-header {
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
    padding: 4px 0;
    transition: background-color 0.2s;
    border-radius: 4px;
    padding-left: 4px;
    margin-left: -4px;
  }

  .filters-header:hover {
    background-color: #f5f5f5;
  }

  .collapse-toggle-btn {
    background: #409eff;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    color: white;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  .collapse-toggle-btn:hover {
    background: #66b1ff;
    transform: scale(1.05);
  }

  .collapse-toggle-btn:active {
    transform: scale(0.95);
  }

  .collapse-toggle-btn i {
    font-size: 12px;
    font-weight: bold;
  }

  .filtersAndSortModal .modal-column-left,
  .filtersAndSortModal .modal-column-right {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 15px;
    box-sizing: border-box;
  }


  .filters-grid {
    display: grid;
    grid-template-columns: 60% 40%;
    gap: 20px;
    overflow-x: hidden;
    width: 100%;
    box-sizing: border-box;
  }

  .slim-header {
    padding: 6px 10px !important;
    border-bottom: 1px solid #e6e6e6;
  }

  .slim-header h4 {
    margin: 0;
  }

  .slim-body {
    padding: 8px !important;
    overflow-x: hidden;
  }

  .filtersAndSortModal .card {
    margin-bottom: 0 !important;
  }

  .filtersAndSortModal .card-content {
    padding: 10px !important;
    overflow-x: hidden;
  }

  .slim-footer {
    text-align: right;
    margin-top: 8px;
    border-top: 1px solid #eee;
    padding-top: 6px;
    padding-bottom: 0 !important;
    padding-left: 15px !important;
    padding-right: 0 !important;
  }

  .slim-footer .el-button {
    font-size: 14px;
  }

  .section-title {
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: 600;
  }

  .filter-section {
    margin-bottom: 14px;
  }

  .filter-section h6 {
    margin-bottom: 8px;
    font-weight: 500;
  }

  .button-group-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .status-filter-buttons .btn-status-filter {
    min-width: 120px;
    padding: 10px 23px;
    border-radius: 50px;
    height: 40px;
    line-height: 19px;
    font-size: 14px;
    font-weight: 400;
    border-color: white;
    white-space: nowrap;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    text-transform: none !important;
    transition: none !important;
    transform: none !important;
  }

  .status-filter-buttons .btn-status-filter:active {
    transform: none !important;
    scale: 1 !important;
  }

  .status-filter-buttons .btn-status-filter:focus {
    outline: none !important;
  }


  .status-filter-buttons .btn-status-filter.btn-default {
    background: #f0f0f0 !important;
    color: #666 !important;
    border: 1px solid #ddd !important;
  }

  .status-filter-buttons .btn-status-filter.btn-default:hover {
    background: #e0e0e0 !important;
    color: #333 !important;
  }

  .payment-type-buttons .btn-status-filter,
  .payment-type-buttons button {
    text-transform: none !important;
  }

  .button-group-wrap.status-filter-buttons .btn-status-filter,
  .button-group-wrap.status-filter-buttons button {
    text-transform: none !important;
  }

  .status-filter-buttons .btn-status-filter.current {
    color: white !important;
  }

  .status-filter-buttons .btn-status-filter.current.NEW {
    background-color: #0097FC !important;
  }

  .status-filter-buttons .btn-status-filter.current.PROCESSING {
    background-color: #F3BB45 !important;
  }

  .status-filter-buttons .btn-status-filter.current.PREPARED {
    background-color: #5e35b1 !important;
  }

  .status-filter-buttons .btn-status-filter.current.DELIVERED {
    background-color: #7AC29A !important;
  }

  .status-filter-buttons .btn-status-filter.current.CANCELED,
  .status-filter-buttons .btn-status-filter.current.NOT_DELIVERED {
    background-color: #EB5E28 !important;
  }

  .status-filter-buttons .btn-status-filter.current.AWAITING_TRANSPORT {
    background-color: #ffc107 !important;
  }

  .status-filter-buttons .btn-status-filter.current.PICKED_UP_BY_DELIVERY {
    background-color: #66615B !important;
  }

  .status-filter-buttons .btn-status-filter.current.TRANSPORT {
    background-color: #0f566a !important;
  }

  .status-filter-buttons .btn-status-filter.current.OPEN_DRAFT {
    background-color: #5e35b1 !important;
  }

  .pill-btn {
    border-radius: 999px !important;
    padding: 4px 10px !important;
    text-transform: none !important;
  }

  .range-row {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .filtersAndSortModal .modal-column-left::-webkit-scrollbar,
  .filtersAndSortModal .modal-column-right::-webkit-scrollbar {
    width: 6px;
  }

  .filtersAndSortModal .modal-column-left::-webkit-scrollbar-track,
  .filtersAndSortModal .modal-column-right::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .filtersAndSortModal .modal-column-left::-webkit-scrollbar-thumb,
  .filtersAndSortModal .modal-column-right::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  .filtersAndSortModal .modal-column-left::-webkit-scrollbar-thumb:hover,
  .filtersAndSortModal .modal-column-right::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .filtersAndSortModal .el-select.w-100 {
    width: 100% !important;
  }

  .filtersAndSortModal .el-select.w-100 .el-input {
    width: 100% !important;
  }

  /* Make loading overlay appear below the filter modal */
  .v--modal-overlay {
    z-index: 1000 !important;
  }

  .v--modal-box {
    z-index: 1001 !important;
  }

  /* Ensure loading overlay is below modal (Element UI default is 2000) */
  .el-loading-mask {
    z-index: 999 !important;
  }
  /* MOBILE ONLY: 1 col, scrollable, fits screen */
  @media screen and (max-width: 1024px),
         screen and (max-width: 768px),
         screen and (max-device-width: 768px) {
    .v--modal-box.filtersAndSortModal {
      max-height: 90vh;
      overflow-y: auto;
      width: 95vw !important;
      max-width: 95vw !important;
      margin: 0 auto;
    }

    .v--modal-box.filtersAndSortModal .filters-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .v--modal-box.filtersAndSortModal .modal-column-left,
    .v--modal-box.filtersAndSortModal .modal-column-right {
      max-height: none;
      padding-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Orders/Orders.vue